import { render, staticRenderFns } from "./DefiTools.vue?vue&type=template&id=5dce1922&"
import script from "./DefiTools.vue?vue&type=script&lang=js&"
export * from "./DefiTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports